import { useEffect, useState } from "react";
import { CardDetails } from "../../../../common/components/CardDetails/CardDetails"
import style from "./style.module.scss"
import { OtherService } from "../../../../common/services/merchandise_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../common/components/Loader/Loader";

type storageOtherDetailType = {
  initialValue: any
}

const StorageOtherDetail = ( {initialValue}: storageOtherDetailType) => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>({});

  const id = initialValue?.["@id"].split("/").pop();

  useEffect(() => {
    id && getStorageOther(id);
  }, [initialValue]);

  const getStorageOther = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await OtherService.getOtherById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

const renderValue = (value : any /* string | number | boolean */) => {
  return value ? value : "-";
};

  return (
    <div>
      <Loader isLoading={isLoading}/>
      <CardDetails className="d-flex gap-2 flex-column">
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Label : </span>
                <span className={style.details__value}>{renderValue(data?.lable)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Description : </span>
                <span className={style.details__value}>{renderValue(data?.description)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Quantité : </span>
                <span className={style.details__value}>{renderValue(data?.qty)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tonnage (T) : </span>
                <span className={style.details__value}>{renderValue(data?.tonnage)}</span>
              </div>
            </CardDetails>
    </div>
  )
}

export default StorageOtherDetail